module.exports = __webpack_public_path__ + "img/4.2fd4ad3a.png";